import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';

import css from './MainPanelHeader.module.css';

/**
 * MainPanelHeader component
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {React.Node} props.children - The children
 * @param {string} [props.heading] - Optional catalog heading above the result count
 * @param {React.Node} props.sortByComponent - The sort by component
 * @param {boolean} props.isSortByActive - Whether the sort by is active
 * @param {boolean} props.listingsAreLoaded - Whether the listings are loaded
 * @param {number} props.resultsCount - The results count
 * @param {string} [props.resultsCountMessageId] - Translation key for the result count
 * @param {boolean} props.searchInProgress - Whether the search is in progress
 * @param {React.Node} props.noResultsInfo - The no results info
 * @returns {JSX.Element}
 */
const MainPanelHeader = props => {
  const {
    rootClassName,
    className,
    children,
    heading,
    sortByComponent,
    isSortByActive,
    listingsAreLoaded,
    resultsCount,
    resultsCountMessageId = 'MainPanelHeader.foundResults',
    searchInProgress = false,
    noResultsInfo,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const showLoadingResults = searchInProgress && !listingsAreLoaded && resultsCount === 0;

  return (
    <div className={classes}>
      <div className={css.searchOptions}>
        <h1 className={css.searchResultSummary}>
          {heading ? <span className={css.catalogHeading}>{heading}</span> : null}
          <span className={css.resultsFound}>
            {showLoadingResults ? (
              <FormattedMessage id="MainPanelHeader.loadingResults" />
            ) : (
              <FormattedMessage id={resultsCountMessageId} values={{ count: resultsCount }} />
            )}
          </span>
        </h1>
        {isSortByActive ? (
          <div className={css.sortyByWrapper}>
            <span className={css.sortyBy}>
              <FormattedMessage id="MainPanelHeader.sortBy" />
            </span>
            {sortByComponent}
          </div>
        ) : null}
      </div>

      {children}

      {noResultsInfo ? noResultsInfo : null}
    </div>
  );
};

export default MainPanelHeader;
